import {
  createRouter as createVueRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";

import defaultRoutes from "./default-routes";

export interface RouteCollection {
  routes: RouteRecordRaw[];
  basePath: `/${string}`;
}

function unwrapRoutes(routes: RouteCollection): RouteRecordRaw[] {
  return routes.routes.map((route) => ({
    ...route,
    path: `${routes.basePath}${route.path}`,
  }));
}

export interface RouterConfig {
  appBaseUrl: string;
}

/**
 * Creates a Vue Router instance with the provided route collection and router configuration.
 *
 * @param {RouteCollection[]} routeCollection - An array of route collections to be unwrapped and flattened into individual routes.
 * @param {RouterConfig} routerConfig - Configuration object for the router, including the base URL for the application.
 * @returns {VueRouter} A Vue Router instance configured with the provided routes and default routes.
 */
export function createRouter(
  routeCollection: RouteCollection[],
  routerConfig: RouterConfig,
) {
  const routes = routeCollection.map(unwrapRoutes).flat();

  return createVueRouter({
    history: createWebHistory(routerConfig.appBaseUrl),
    routes: [...routes, ...defaultRoutes],
  });
}
